import React from 'react';
import './Blogs.css';

const Blogs = () => {
  return (
    <section id="blogs" className="blogs section">
      <div className="container">
        <h2 className="section-title">ÜBER UNS</h2>

        <div className="simple-text">
          <p>
            Wir sind SK Dienstleistungen – Ihr professioneller Partner für zuverlässige Gartenpflege,
            professionelle Hausmeisterdienste und die Betreuung von Außenanlagen. Mit Blick fürs Detail
            und einem klaren Fokus auf die Zufriedenheit unserer Kunden kümmern wir uns um
            Mehrfamilienhäuser, Wohnanlagen und Firmengelände in der Region Lindau (Bodensee),
            Wasserburg, Nonnenhorn und Umgebung. Unser Team sorgt dafür, dass Gärten, Außenanlagen
            und Gebäude gepflegt bleiben, damit Ihre Immobilie nicht nur schön aussieht, sondern auch
            ihren Wert langfristig behält. Ein gepflegtes Gebäude braucht regelmäßige Betreuung und
            einen Ansprechpartner, auf den man sich verlassen kann – als Ihr Hauswart stehen wir Ihnen
            jederzeit zur Seite.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Blogs;
